@if (form) {
    <form [formGroup]="form" [fxHide]="Spinner.isShown('initForms')" class="w-100 h-fit-content" fxLayout="column" fxLayoutAlign="start start">
        <mat-accordion class="w-100">
            @for (trendIncidentForm of form.controls?.trendIncidents?.controls; track trackByTrendIncidentIndex(index, trendIncidentForm); let
                index = $index; let first = $first; let last = $last) {
                <af-trend-incident-expansion-panel
                    [trendIncident]="trendIncidents && trendIncidents[index]"
                    [trendIncidentForm]="trendIncidentForm"
                    [expanded]="!Spinner.isShown('initForms') && last"
                    [showDeleteButton]="showDeleteButton"
                    [index]="index"
                    [viewIndex]="trendIncidentForm.controls.incidentId.value"
                    (deleteTrendIncidentListener)="deleteTrendIncident($event)"
                />
            }
        </mat-accordion>

        <div fxLayout="row" fxLayoutAlign="space-between center" class="w-824">
            <div fxLayout="row" fxLayoutAlign="start center" class="mt-40">
                <ui-kit-button spinnerId="submit"
                               [disabled]="form.invalid"
                               (clickListener)="submit()"
                               [label]="'i18n_af_buttonNext' | translate"/>

            </div>
            <ui-kit-button type="secondary"
                           (clickListener)="previousStep.emit()"
                           [label]="'i18n_af_buttonBack' | translate"/>
        </div>

    </form>
}
